import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstanceID } from '../../Apis/Axios';
import {ADVANCED_SEARCH_SERVICE, HID_SERVICE, STATUS_SERVICE, ZONE_SERVICE} from "../EndPoints";

export const GetHidRecordDetails = createAsyncThunk(
    'hid/getHidRecordDetails',
    async (params, { dispatch, getState }) => {
        const { id } = params;
        const result = await apiInstanceID
            .get(`${HID_SERVICE.getHidRecordDetails}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const CreateHidRecord = createAsyncThunk('hid/createHidRecord', async (body) => {
    const response = await apiInstanceID
        .post(HID_SERVICE.createHidRecord, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetSio = createAsyncThunk('hid/getSio', async (params, { dispatch, getState }) => {
    const result = await apiInstanceID
        .get(HID_SERVICE.getSio)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
// /get-by-user-id/{userId}provider-module in provider-controller
export const GetAllSiosByHidId = createAsyncThunk('hid/getAllSiosByHidId', async (params, { dispatch, getState }) => {
    const { hidId } = params;
    const result = await apiInstanceID
        .get(`${HID_SERVICE.getAllSiosByHidId}${hidId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
export const CreateHidSioRecord = createAsyncThunk('hid/createHidSioRecord', async (body) => {
    const response = await apiInstanceID
        .post(HID_SERVICE.createHidSioRecord, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const CreateHidInput = createAsyncThunk('hid/createHidInput', async (body) => {
    const response = await apiInstanceID
        .post(HID_SERVICE.createHidInput, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateHidOutput = createAsyncThunk('hid/createHidOutput', async (body) => {
    const response = await apiInstanceID
        .post(HID_SERVICE.createHidOutput, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateFormat = createAsyncThunk('hid/createFormat', async (body) => {
    const response = await apiInstanceID
        .post(HID_SERVICE.createFormat, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const CreateHidReader = createAsyncThunk('hid/createHidReader', async (body) => {
    const response = await apiInstanceID
        .post(HID_SERVICE.createHidReader, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateHidAcr = createAsyncThunk('hid/createHidAcr', async (body) => {
    const response = await apiInstanceID
        .post(HID_SERVICE.createHidAcr, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const UpdateHidRecord = createAsyncThunk('hid/updateHidRecord', async (body, { dispatch, getState }) => {
    const result = await apiInstanceID
        .put(HID_SERVICE.updateHidRecord, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});


export const ConnectWithHid = createAsyncThunk('hid/connectWithHid', async (params, { dispatch, getState }) => {
    const { id } = params;
    const result = await apiInstanceID
        .get(`${HID_SERVICE.connectWithHid}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
export const SendInformationSetting = createAsyncThunk(
    'hid/sendInformationSetting',
    async (params, { dispatch, getState }) => {
        const { id } = params;
        const result = await apiInstanceID
            .get(`${HID_SERVICE.sendInformationSetting}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const AdvanceSearchByFilters = createAsyncThunk(
    'hid/advanceSearchByFilters',
    async ({ option, body }, { dispatch, getState }) => {
        window.postMessage(
            {
                /*  type: 'sessionStorageChangeLoader',
                newValueLoading: true, */
            },
            '*',
        );
        let result = await apiInstanceID
            .post(`${ADVANCED_SEARCH_SERVICE.searchByFilters}${option}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const ResetHid = createAsyncThunk('hid/resetHid', async (params, { dispatch, getState }) => {
    const { id } = params;
    const result = await apiInstanceID
        .delete(`${HID_SERVICE.resetHid}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});


export const GetAcrZonesAvailable = createAsyncThunk('hid/getAcrZonesAvailable', async (param, { dispatch, getState }) => {
    const result = await apiInstanceID
        .get(HID_SERVICE.getAcrZonesAvailable)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetAcrReadersAvailableBySio = createAsyncThunk('hid/getAcrReadersAvailableBySio', async (params, { dispatch, getState }) => {
    const result = await apiInstanceID
        .get(
    `${HID_SERVICE.getAcrReadersAvailableBySio}${params.isEntry}/${params.hidSioId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetAcrOutputsAvailableBySio = createAsyncThunk('hid/getAcrOutputsAvailableBySio', async (id, { dispatch, getState }) => {
    const result = await apiInstanceID
        .get(`${HID_SERVICE.getAcrOutputsAvailableBySio}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetAcrInputsNormallyCloseBySio = createAsyncThunk('hid/getAcrInputsNormallyCloseBySio', async (id, { dispatch, getState }) => {
    const result = await apiInstanceID
        .get(`${HID_SERVICE.getAcrInputsNormallyCloseBySio}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetAcrInputsNormallyOpenBySio = createAsyncThunk('hid/getAcrInputsNormallyOpenBySio', async (id, { dispatch, getState }) => {
    const result = await apiInstanceID
        .get(`${HID_SERVICE.getAcrInputsNormallyOpenBySio}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetInputTypeConnections = createAsyncThunk('hid/getInputTypeConnections', async (id, { dispatch, getState }) => {
    const result = await apiInstanceID
        .get(HID_SERVICE.getInputTypeConnections)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const OpenTheDoor = createAsyncThunk('hid/openTheDoor', async (acrId, { dispatch, getState }) => {
    const result = await apiInstanceID
        .get(`${HID_SERVICE.openTheDoor}${acrId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
export const LinkingMode = createAsyncThunk('hid/linkingMode', async (acrId, { dispatch, getState }) => {
    const result = await apiInstanceID
        .get(`${HID_SERVICE.linkingMode}${acrId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
